export enum HelperType {
  INFO = 0,
  SUCCESS = 1,
  WARNING = 2,
  DANGER = 3,
  DARK = 4,
  NO_INFO = 5
}
